// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/identity.js
// module id = 373
// module chunks = 1